import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import globalEvents from "web/script/utils/global-events";
import requester from "web/script/modules/requester";


export default baustein.register("saved-search-delete-confirmation", {
    defaultOptions: {
        deleteSavedSearchId: null,
    },

    setupEvents(add) {
        add("click", ".confirmation-prompt__button--yes", this.delete);
        add("click", ".confirmation-prompt__button--no", this.closeOverlay);
    },

    closeOverlay() {
        analytics.event("clicked", "no delete saved search");
        globalEvents.trigger("confirmation-prompt-closed");
    },

    delete() {
        analytics.event("clicked", "yes delete saved search").then(() => {
            requester
                .post(`/my-searches/delete/${this.options.deleteSavedSearchId}/`, {})
                .then((response) => {
                    if (response && response.success) {
                        globals.window.location = response.data.redirect_url;
                    }
                });
        });
    },
});
